import React from "react";
import styled from "@emotion/styled";
import { Checkbox } from "antd5";
import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";
import Modal from "components/ui/modal/Modal";
import UIcon from "lib/icons/untitled_ui/UIcon";

export const HIDE_SAVE_SUPPLIER_MODAL = "HIDE_SAVE_SUPPLIER_MODAL";

export type SaveSupplierModalProps = {
  open: boolean;
  onOpenChange: (open: boolean, actionType?: "Confirm" | "Cancel") => void;
  isBulkSave: boolean;
  action?: "Save" | "Remove";
  type?: "partner" | "competitor";
};

function SaveSupplierModal({
  open,
  onOpenChange,
  type,
  isBulkSave,
  action,
}: SaveSupplierModalProps) {
  if (!action || !type) {
    if (open) {
      console.error("SaveSupplierModal requires 'action' and 'type' props to be defined");
    }
    return null;
  }

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      position="top-center"
      maxWidth="500px"
      showCloseButton={false}
      backgroundClickClose={false}
    >
      <Content column gap={16}>
        <Flex gap={12} alignItems="center">
          <UIcon icon="infoCircle" size={24} />
          <Text h2>
            {isBulkSave
              ? `${action} suppliers ${action === "Save" ? "as" : "from"} ${type} signals`
              : `${action} supplier as a ${type} signal`}
          </Text>
        </Flex>
        <Text>
          {isBulkSave
            ? `${action === "Save" ? "Saving" : "Removing"} these suppliers as ${type} signals `
            : `${action === "Save" ? "Saving" : "Removing"} this supplier as a ${type} signal `}
          will also update your signal settings and could affect your saved views, including the
          views owned by other users in your team.
        </Text>
        <Flex gap={8} alignItems="center" justifyContent="space-between">
          <Checkbox
            onChange={(e) => localStorage.setItem(HIDE_SAVE_SUPPLIER_MODAL, `${e.target.checked}`)}
          >
            Don't show me this again
          </Checkbox>
          <Flex gap={8}>
            <Button buttonType="secondary" onClick={() => onOpenChange(false, "Cancel")}>
              Cancel
            </Button>
            <Button onClick={() => onOpenChange(false, "Confirm")}>Continue</Button>
          </Flex>
        </Flex>
      </Content>
    </Modal>
  );
}

const Content = styled(Flex)({
  padding: "16px",
});

export default SaveSupplierModal;
